import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-centers-center-new-schedule-dashboard',
  templateUrl: './centers-center-new-schedule-dashboard.component.html',
  styleUrls: ['./centers-center-new-schedule-dashboard.component.scss']
})
export class CentersCenterNewScheduleDashboardComponent implements OnInit {

  centerid;

  constructor(private activatedRoute: ActivatedRoute,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.centerid = this.activatedRoute.snapshot.params['centerid'];
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-day', 'schedule-page.new schedule', '/center/' + this.centerid, [new BRoute('stores-page.store locator', '/centers'), new BRoute('stores-page.store detail', '/center/' + this.centerid), new BRoute('schedule-page.new schedule')]));
  }
}
